// extracted by mini-css-extract-plugin
module.exports = {"centerChildrenVertically":"centerChildrenVertically_centerChildrenVertically__kI9Q0"};